import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BookCard.module.css';
import { resolveCoverUrl } from '../services/api';

const BookCard = ({ book, showDetails = false, showStatus = false, from }) => {
  const navigate = useNavigate();
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);
  
  const handleClick = () => {
    console.log('[BookCard] 点击书籍:', book.title, 'bookId:', book.id);
    console.log('[BookCard] from:', from);
    console.log('[BookCard] history.length before push:', window.history.length);
    navigate(`/book?bookid=${book.id}`, { state: { from } });
  };

  const handleReadClick = (e) => {
    e.stopPropagation(); // 阻止事件冒泡
    navigate(`/book?bookid=${book.id}`, { state: { from } });
  };





  const pickCover = (b) => {
    if (typeof b?.cover_image_url === 'string') return b.cover_image_url.trim();
    if (typeof b?.cover_img_url === 'string') return b.cover_img_url.trim();
    if (typeof b?.novel_cover_image_url === 'string') return b.novel_cover_image_url.trim();
    if (typeof b?.cover === 'string') return b.cover.trim();
    return '';
  };

  const rawCover = pickCover(book);
  const coverUrl = resolveCoverUrl(rawCover);

  // 获取书籍状态
  const getBookStatus = () => {
    if (book.is_completed !== undefined) {
      return book.is_completed ? '完结' : '连载中';
    }
    return book.status || '未知';
  };

  return (
    <div className={styles.bookCard} onClick={handleClick}>
      {(book.is_completed !== undefined || book.status) && (
        <span className={
          book.is_completed
            ? styles.bookStatusCompleted
            : styles.bookStatusOngoing
        }>
          {getBookStatus()}
        </span>
      )}
      <div className={styles.bookCardContent}>
        <div className={styles.bookCover} aria-hidden="true">
          {coverUrl && !imageError ? (
            <>
              <img
                src={coverUrl}
                alt={book.title}
                className={styles.coverImage}
                loading="lazy"
                onLoad={() => setImageLoading(false)}
                onError={() => {
                  setImageLoading(false);
                  setImageError(true);
                }}
              />
              {imageLoading && <div className={styles.coverLoading}>加载中</div>}
            </>
          ) : (
            <div className={styles.coverPlaceholder}>暂无封面</div>
          )}
        </div>
        <div className={styles.bookInfo}>
          <div className={styles.bookMainInfo}>
            <h3 className={styles.bookTitle}>{book.title}</h3>
            <p className={styles.bookAuthor}>{book.author}</p>
          </div>
          
          {showDetails && (
            <div className={styles.bookDetails}>
              <div className={styles.detailItem}>
                <span className={styles.detailLabel}>状态：</span>
                <span className={styles.detailValue}>{getBookStatus()}</span>
              </div>
              {book.categories && book.categories.length > 0 && (
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>分类：</span>
                  <span className={styles.detailValue}>
                    {book.categories.map(cat => cat.name).join(', ')}
                  </span>
                </div>
              )}
              {book.createdAt && (
                <div className={styles.detailItem}>
                  <span className={styles.detailLabel}>创建时间：</span>
                  <span className={styles.detailValue}>
                    {new Date(book.createdAt).toLocaleDateString()}
                  </span>
                </div>
              )}
            </div>
          )}

          {book.description && (
            <div className={styles.bookDescriptionSection}>
              <p className={styles.bookDescription}>
                {book.description.length > 100
                  ? `${book.description.substring(0, 100)}...`
                  : book.description}
              </p>
            </div>
          )}
        </div>
      </div>
      
  
    </div>
  );
};

export default BookCard;
